import { render } from "./Before-after-price.vue?vue&type=template&id=0badb667&scoped=true"
import script from "./Before-after-price.vue?vue&type=script&lang=js"
export * from "./Before-after-price.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=0badb667&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0badb667"]])

export default __exports__